import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Stack, Text, Button, Center, Paper, Code } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { setCurrentPage } from '../redux/app.slice';
import { stripeApi } from '../apis/stripe.api';

const SubscriptionError = () => {
  const dispatch = useDispatch();
  const [errorDetails, setErrorDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(setCurrentPage('subscription-error'));
    
    const logErrorDetails = async () => {
      const searchParams = new URLSearchParams(window.location.search);
      const sessionId = searchParams.get('session_id');
      const errorType = searchParams.get('error_type');
      const errorMessage = searchParams.get('error_message');
      
      const errorData = {
        timestamp: new Date().toISOString(),
        sessionId,
        errorType,
        errorMessage,
        fullUrl: window.location.href,
        searchParams: Object.fromEntries(searchParams.entries()),
      };

      try {
        if (sessionId) {
          // Attempt to get additional session details if available
          const sessionDetails = await stripeApi.getSessionDetails(sessionId);
          errorData.sessionDetails = sessionDetails;
        }
      } catch (error) {
        errorData.sessionFetchError = error.message;
      }

      console.error('Subscription Error Details:', errorData);
      setErrorDetails(errorData);
      setLoading(false);
    };

    logErrorDetails();
  }, [dispatch]);

  if (loading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Paper p="xl" shadow="sm" radius="md">
          <Stack align="center" spacing="md">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            <Text size="xl" weight={500} align="center">
              Processing Error Details
            </Text>
          </Stack>
        </Paper>
      </Center>
    );
  }

  return (
    <Center style={{ height: '100vh' }}>
      <Paper p="xl" shadow="sm" radius="md" style={{ maxWidth: '600px' }}>
        <Stack align="center" spacing="md">
          <IconAlertCircle size={48} color="red" />
          <Text size="xl" weight={500} align="center" color="red">
            Subscription Error
          </Text>
          <Text color="dimmed" size="sm" align="center">
            {errorDetails?.errorMessage || 'An error occurred with your subscription'}
          </Text>
          
          {process.env.NODE_ENV === 'development' && (
            <Code block>
              {JSON.stringify(errorDetails, null, 2)}
            </Code>
          )}
          
          <Stack spacing="xs">
            <Button onClick={() => window.close()}>
              Close Window
            </Button>
            <Button 
              variant="subtle" 
              onClick={() => window.location.href = '/support'}
            >
              Contact Support
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Center>
  );
};

export default SubscriptionError;